export const appendPropsToComponent = (
  element: JSX.Element,
  extraProps: any,
) => {
  return <element.type {...element.props} {...extraProps} />;
};
